import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

import Button from "../../components/Button";

import { getPaymentRecord } from "./api/billingRequest";
import { useTranslation } from "../../i18n/TranslationProvider";

export default function Invoice() {
    const navigate = useNavigate();
    const { userId, userProfile } = useAuth();
    const { t } = useTranslation();

    const [invoice, setInvoice] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchInvoice = async () => {
            try {
                const res = await getPaymentRecord(userId);
                const invoice = res.data?.invoice;
                setInvoice(invoice);
                setLoading(false);
            } catch (err) {
                console.error("Error fetching payment record:", err);
            }
        };

        fetchInvoice();
    }, [userId]);

    if (loading) {
        return <h6 className="text-center text-lg font-normal">{t("common.loading")}</h6>;
    }

    const {
        number,
        amount_due,
        customer_name,
        customer_email,
        effective_at,
        status,
        invoice_pdf,
    } = invoice;

    const formattedAmount = (amount_due / 100).toFixed(2);
    const effectiveDate = new Date(effective_at * 1000).toLocaleDateString();
    const endDate = new Date(
        new Date(effective_at * 1000).setFullYear(
            new Date(effective_at * 1000).getFullYear() + 1
        )
    ).toLocaleDateString();
    const formattedStatus = status === "paid" ? t("invoice.statusPaid") : t("invoice.statusPending");

    const handleDownloadInvoice = () => {
        window.location.href = invoice_pdf;
    };

    // TODO: TEMPORARY — replace localStorage with real user DB field once backend is ready
    // const productType = localStorage.getItem("productType");
    
    const postInvoiceRoute = userProfile?.iiss_type === "emr" ? "/emr-dashboard" : "/add-new-athletes";
    const postInvoiceLabel = userProfile?.iiss_type === "emr" ? t("invoice.goToEmrDashboard") : t("athletes.uploadRosterPageHeading");

    return (
        <div className="custom-container mx-auto w-4/5 md:w-2/3 lg:w-1/2 ">
            <h3 className="text-center text-lg md:text-2xl mb-2">
                {t("invoice.thankYouHeading")}
            </h3>
            <p className="text-center">
                {t("invoice.subtext")}
            </p>
            <div className="flex flex-col gap-2 border border-primary mt-6 py-4 px-4 shadow">
                <h6 className="text-base md:text-lg">{t("invoice.detailsHeading")}</h6>
                <p>{t("invoice.numberLabel")} {number}</p>
                <p>{t("invoice.amountDueLabel")} ${formattedAmount} {t("invoice.usdSuffix")}</p>
                <p>{t("invoice.customerLabel")} {customer_name}</p>
                <p>{t("invoice.emailLabel")} {customer_email}</p>
                <p>{t("invoice.effectiveDateLabel")} {effectiveDate}</p>
                <p>{t("invoice.endDateLabel")} {endDate}</p>
                <p>
                    {t("invoice.statusLabel")}{" "}
                    <span
                        className={`capitalize font-semibold ${
                            status === "paid"
                                ? "text-green-600"
                                : "text-yellow-600"
                        }`}
                    >
                        {formattedStatus}
                    </span>
                </p>
                <Button
                    variant="outline"
                    className="w-full mt-4"
                    onClick={handleDownloadInvoice}
                >
                    {t("invoice.downloadButton")}
                </Button>
            </div>
            <Button
                className="w-full mt-4"
                onClick={() => navigate(postInvoiceRoute)}
            >
                {postInvoiceLabel}
            </Button>
        </div>
    );
}